import React from 'react'

import { Field } from 'ui/components/Field'
import { ItemSelector } from 'ui/components/ItemSelector'

import { useToolInputTableAccessState } from './hooks/useToolInputTableAccessState'

const MAX_TABLE_NAME_LENGTH = 25

export const ToolInputTableAccess: React.FC = () => {
    const { suppliedTables, tableOptions, error, onChange } = useToolInputTableAccessState()

    return (
        <Field label="Table access" helperText={error?.message} isError={!!error}>
            <ItemSelector
                items={tableOptions}
                value={suppliedTables}
                onChange={onChange}
                maxLabelLength={MAX_TABLE_NAME_LENGTH}
            />
        </Field>
    )
}
